import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const manageBookmark = createAsyncThunk("stories/manageBookmark", async (data, Thunk) => {
  try {
    let response = await axios.post("bookmark/manage", data);
    return response?.data;
  } catch (error) {
    return Thunk.rejectWithValue(error);
  }
});

export const getBookmarksList = createAsyncThunk(
  "stories/getBookmarksList",
  async (filters, Thunk) => {
    try {
      let response = await axios.post("bookmarks/list", filters);
      const { data = {} } = response.data || {};

      const records = [];
      for await (let item of data?.records) {
        records.push(item.story);
      }
      return {
        ...response?.data,
        data: { records, totalCount: data?.totalCount || 0 },
      };
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  }
);
